import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import Container from "./Container";

const RemoveProduct = ({ 
    data, removeProductPopup, 
    changeRemoveItemPopup
}) => {
    return (
        <Dialog open={removeProductPopup} onOpenChange={changeRemoveItemPopup}>
            <DialogTrigger
                asChild
                id=""
            >
                <Button
                    variant="secondary"
                    className="
                        bg-transprent hover:bg-transprent rounded-none 
                        px-2 py-0 h-[45px] w-[45px] border-0 absolute top-0 right-0
                        items-center justify-between cursor-pointer 
                    "
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={22}
                        height={22}
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M16 8L8 16M8.00001 8L16 16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                            stroke="#393939bf"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Button>
            </DialogTrigger>
            <Container 
                data={data} 
                changeRemoveItemPopup={changeRemoveItemPopup} 
            />
        </Dialog>
    )
}

export default RemoveProduct